import React, { useMemo } from 'react';

import { Map } from '../../Map';

function HotelMap({hotel, tickets, zoom, interactive, onClick}) {
    const center = useMemo(() => ({
        lat: parseFloat(hotel.map.lat),
        lng: parseFloat(hotel.map.lng),
    }), [hotel]);

    const pins = useMemo(() => {
        const pins = [
            {
                type: 'red',
                lng: parseFloat(hotel.map.lng),
                lat: parseFloat(hotel.map.lat),
                popup: hotel.name,
            },
        ];

        if (
            tickets &&
            tickets[0].venue &&
            tickets[0].venue.arena &&
            tickets[0].venue.arena.map
        ) {
            pins.push({
                type: 'blue',
                lng: parseFloat(tickets[0].venue.arena.map.lng),
                lat: parseFloat(tickets[0].venue.arena.map.lat),
                popup: tickets[0].venue.arena.title,
            });
        }

        return pins;
    }, [hotel, tickets]);

    return (
        <Map
            center={center}
            pins={pins}
            zoom={zoom}
            interactive={interactive}
            scale={false}
            onClick={onClick}
        />
    );
}

export { HotelMap };
